// Normalize base URL: trim trailing slashes to avoid double slashes when concatenating
const raw = (process.env.REACT_APP_API_BASE || '').trim();
const API_BASE = raw ? raw.replace(/\/+$/, '') : '';

export default API_BASE;
